import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import ContactBar from './components/ContactBar';
import AppleNavigation from './components/AppleNavigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { SEORouter } from './seo';
import { initializePerformanceMonitoring } from './seo/utils/performance';
import './design-system.css';
import './styles/base-2025.css';
import './styles/glossy-effects.css';
import './styles/responsive.css';

// Professional App Component - Clean and Accessible

function App() {
  useEffect(() => {
    // Initialize performance monitoring
    initializePerformanceMonitoring();

    // Optimize font loading (disabled until local fonts are added)
    // optimizeFontLoading();

    // Initialize analytics (uncomment when ready to use)
    // initializeGA4('YOUR_GA_MEASUREMENT_ID');
    // initializeClarity('YOUR_CLARITY_PROJECT_ID');
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <div className='app-container surface min-h-screen'>
            <a href='#main-content' className='skip-link'>
              Skip to main content
            </a>
            <Router>
              <ScrollToTop />
              <div className='flex flex-col min-h-screen'>
                <ContactBar />
                <AppleNavigation />
                <SEORouter />
                <Footer />
              </div>
            </Router>
          </div>
        </ErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
